import React, {useState, useEffect} from "react";
import {CalendarOutlined, DownloadOutlined} from "@ant-design/icons";
import {observer} from "mobx-react-lite";
import DatePickerForReportPage from "../../../_defaultComponents/FilterComponents/DatePickerForReportPage";
import {SubCompanyFilter} from "../../../_defaultComponents/FilterComponents";
import {
    FilterSection,
    FilterTitle,
    ButtonContainer,
    DownloadButton,
    ReportsFilterContainer,
    FiltersContainer,
    SubCompanyFilterWrapper,
    DatePickerWrapper
} from "../CustomerReportsPage.styles";
import {useStore} from "../../../../hooks/useStore";

const CustomerReportsFilters = ({
    // Date picker props
    period,
    setPeriod,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    showAllTime = false,
    showNextButton = false,
    showPrevButton = false,

    // Sub company props
    hasMultipleSubcompanies,
    company,
    subCompany,
    setSubCompany,

    // State management
    isDatePickerExpanded,
    setIsDatePickerExpanded,

    // Report download props
    handleOrderReportDownload,
    orderReportLoading,
    handleShiftReportDownload,
    shiftReportLoading,
    reportType // "order" or "shift"
}) => {
    const stores = useStore();
    const selectedSubCompanyId = stores?.meStore?.selectedSubCompanyId;

    useEffect(() => {
        if (selectedSubCompanyId) {
            setSubCompany([selectedSubCompanyId]);
        }
    }, [selectedSubCompanyId, setSubCompany]);

    return (
        <FilterSection>
            <ReportsFilterContainer>
                <FiltersContainer>
                    <DatePickerWrapper>
                        <DatePickerForReportPage
                            period={period}
                            setPeriod={setPeriod}
                            startDate={startDate}
                            setStartDate={setStartDate}
                            endDate={endDate}
                            setEndDate={setEndDate}
                            showAllTime={showAllTime}
                            showNextButton={showNextButton}
                            showPrevButton={showPrevButton}
                            onDatePickerExpandedChange={setIsDatePickerExpanded}
                        />
                    </DatePickerWrapper>
                    {hasMultipleSubcompanies && (
                        <SubCompanyFilterWrapper
                            isExpanded={isDatePickerExpanded}
                            style={{
                                minWidth: "200px",
                                maxWidth: "250px"
                            }}
                        >
                            <SubCompanyFilter
                                defaultValue={subCompany}
                                company={company}
                                value={subCompany}
                                onChange={setSubCompany}
                                showAllOption={true}
                                allowClear={true}
                                mode="multiple"
                                showSearch={true}
                                initialCall={true}
                            />
                        </SubCompanyFilterWrapper>
                    )}
                </FiltersContainer>
                <ButtonContainer>
                    <DownloadButton
                        type="primary"
                        size="large"
                        icon={<DownloadOutlined />}
                        onClick={
                            reportType === "order"
                                ? handleOrderReportDownload
                                : handleShiftReportDownload
                        }
                        loading={orderReportLoading}
                    >
                        Raporu İndir
                    </DownloadButton>
                </ButtonContainer>
            </ReportsFilterContainer>
        </FilterSection>
    );
};

export default observer(CustomerReportsFilters);
